<span class="status-indicator mr-2 bg-{{colorClass}}" [style.background-color]="color"></span>
<span [class.strong]="strong">{{label}}</span>
<app-user-icon *ngIf="user" class="ml-2" [user]="user" size="xs" [hasTooltip]="!ngbTooltip"></app-user-icon>
<ng-content></ng-content>
